import React, { useState, useEffect } from "react";
import { Flag, Sparkles } from "lucide-react";

// Reusable floating CTA pill for every concept/demo site.
// Links to the personalized MySiteCare PH sales page for that business.
export default function ConceptCTAPill({ slug }) {
  const [visible, setVisible] = useState(false);
  const tagalog = typeof window !== "undefined" && window.localStorage.getItem("mysitecare-language") === "tl";
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 260);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <aside className={`fixed z-40 bottom-20 sm:bottom-24 right-3 md:right-6 flex flex-col items-end gap-2 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`} data-testid="concept-cta-actions">
    <a
      href={`/ph/why-this-matters?biz=${slug}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="concept-cta-pill"
      className="inline-flex min-h-11 items-center gap-2 rounded-full bg-[#0F172A] text-white p-2 sm:pl-3 sm:pr-4 sm:py-2.5 shadow-xl border border-white/10 hover:bg-[#1E293B] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#34D399] transition-[background-color] duration-300 text-xs sm:text-sm font-medium max-w-[calc(100vw-1.5rem)]"
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#10B981]/20">
        <Sparkles size={14} className="text-[#34D399]" />
      </span>
      <span className="flex items-center sm:flex-col sm:items-start leading-tight">
        <span className="hidden sm:block text-[10px] uppercase tracking-wide text-slate-400">{tagalog ? "Konseptong website ng MySiteCare" : "Concept website by MySiteCare"}</span>
        <span className="text-white"><span className="sm:hidden">{tagalog ? "Bakit ang konseptong ito?" : "Why this concept?"}</span><span className="hidden sm:inline">{tagalog ? "Bakit ito mahalaga →" : "Why this matters &rarr;"}</span></span>
      </span>
    </a>
    <a
      href={`/concept-correction?slug=${encodeURIComponent(slug)}`}
      data-testid="concept-correction-cta"
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-3 py-2 text-xs font-medium text-slate-700 shadow-md hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0F172A] transition-[background-color] duration-300"
    >
      <Flag size={13} aria-hidden="true" /> Claim, correct, or remove
    </a>
    </aside>
  );
}
